var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { lazy as _lazy } from 'react';
function retry(factory, retries = 5, interval = 1000) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield factory();
            return result;
        }
        catch (error) {
            if (retries === 0)
                throw error;
            setTimeout(() => retry(factory, retries - 1, interval), interval);
        }
    });
}
const lazy = factory => _lazy(() => retry(factory));
export default lazy;
